import { useRef, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { faCheckCircle, faPencil, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@mui/material';
import classNames from 'classnames';

function CommonMultiLineTextInput({ label, initialValue, labelClassName, maxLength, onSave }) {
  const [spinner, setSpinner] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [value, setValue] = useState(initialValue);

  const editRef = useRef(null);
  const readOnlyRef = useRef(null);

  const handleSave = async () => {
    setSpinner(true);
    await onSave(value);
    setEditMode(false);
    setSpinner(false);
  };

  useEffect(() => {
    const ref = editMode ? editRef.current : readOnlyRef.current;

    if (ref) {
      ref.style.height = 'auto';
      ref.style.height = `${Math.min(ref.scrollHeight, 150)}px`;
    }
  }, [editMode]);

  const handleCancel = () => {
    setEditMode(!editMode);
    setValue(initialValue);
  };

  return (
    <>
      <Form.Label className={`bo-common-input-label ${labelClassName}`}>{label}</Form.Label>
      {editMode ? (
        <div className="bo-common-multiline-text-input-container">
          <div className="w-100">
            <Form.Control
              ref={editRef}
              className="bo-common-multiline-text-input"
              as="textarea"
              value={value}
              onChange={e => setValue(e.target.value)}
              maxLength={maxLength}
              readOnly={spinner}
              onInput={() => {
                if (editRef.current) {
                  editRef.current.style.height = 'auto';
                  editRef.current.style.height = `${Math.min(editRef.current.scrollHeight, 150)}px`;
                }
              }}
              rows={1}
            />
            <div
              className={classNames(
                'bo-common-text-bottom-border',
                'bo-common-text-bottom-border-active',
              )}
            />
          </div>
          <div
            className={classNames(
              'bo-common-input-button-container',
              'bo-common-input-button-container-active',
            )}
          >
            {spinner ? (
              <div className="h-100">
                <CircularProgress color="inherit" size={16} />
              </div>
            ) : (
              <>
                <Button
                  className="bo-common-input-button-icon"
                  onClick={handleSave}
                  disabled={maxLength && value.length !== maxLength}
                >
                  <FontAwesomeIcon icon={faCheckCircle} color="#5946A4" size="1x" />
                </Button>
                <Button className="bo-common-input-button-icon" onClick={handleCancel}>
                  <FontAwesomeIcon icon={faTimesCircle} color="#5946A4" size="1x" />
                </Button>
              </>
            )}
          </div>
        </div>
      ) : (
        <Button
          className="bo-common-multiline-text-input-container"
          onClick={() => setEditMode(true)}
        >
          <div className="w-100">
            <Form.Control
              ref={readOnlyRef}
              className="bo-common-multiline-text-input"
              as="textarea"
              readOnly
              value={value}
              onChange={e => setValue(e.target.value)}
              rows={1}
            />
            <div className="bo-common-text-bottom-border" />
          </div>
          <div className="bo-common-input-button-container">
            <div className="bo-common-input-button-icon">
              <FontAwesomeIcon icon={faPencil} color="#5946A4" size="sm" />
            </div>
          </div>
        </Button>
      )}
    </>
  );
}

export default CommonMultiLineTextInput;
